'use client';

import { useAppSelector } from 'lib/hooks';
import CaretIcon from './icons/CaretIcon';
import UIButton from './buttons/UIButton';
import { selectHasRecommendation } from 'slices/selectors';
import { captureConversationStarted } from 'lib/analytics';

import styles from 'styles/CTABanner.module.scss';

const CTABanner = () => {
  const hasRecommendation = useAppSelector((state) =>
    selectHasRecommendation(state)
  );
  if (hasRecommendation) {
    return null;
  }

  return (
    <aside className={styles.cta}>
      <div>
        <h4>Looking for stress free guidance?</h4>
        <p>
          Spend a few minutes with <b>ALEX</b> and get your personalized
          recommendation.
        </p>
      </div>
      <UIButton
        buttonType="tertiary"
        label="Help me pick a plan"
        icon={<CaretIcon direction="right" size="large" />}
        href="/check-audio"
        onClick={() => captureConversationStarted('cta_banner')}
      />
    </aside>
  );
};

export default CTABanner;
